import { Dialog, DialogContent, styled } from '@mui/material';

export const Modal = styled(Dialog)``;

Modal.defaultProps = {
    PaperProps: {
        sx: {
            width: '100%',
            height: '100vh',
            maxWidth: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
    },
};

export const ModalContent = styled(DialogContent)`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    padding: 0;
    margin: 20px 24px;
`;
